import appConfig from '@configs/appConfig';

export const getFullEmail = mailName =>
  mailName.concat('@').concat(appConfig.mailBoxDomain);

export const keyBy = (array, key) =>
  (array || []).reduce((r, x) => ({ ...r, [key ? x[key] : x]: x }), {});
